import React from 'react';
import TypedLink from '../TypedLink/TypedLink.js';
import SlideInContent from '../AnimatedElements/SlideInContent.js';
import Accordion from '../AnimatedElements/Accordion.js';
import { ReactSVG } from "react-svg";
import './ProductsMenu.css';

class ProductsMenu extends React.Component {

  emptyFormData = {
    coupon_code: '',
  };

  emptyFormErrors = {
    coupon_code: '',
  };

  animationObjectRef = new React.createRef();

  constructor(props) {
    super(props);

    this.state = {
      show: false
    };
  }

  is_visible() {
    return this.state.show;
  }

  show() {
    this.setState({ show: true });
    this.animationObjectRef.current.setVisible(true);
  }

  hide() {
    this.setState({ show: false });
    this.animationObjectRef.current.setVisible(false);
    window.AppFooterMenuRef.current.set_item_inactive_by_name('products_menu');
  }

  toggle() {
    if (this.state.show) {
      this.hide();
    }
    else {
      this.show();
    }
  }

  show_accordion_header(item,accordion_item_ref) {

    const onClick = (parseInt(item.active_url)) ? ()=>{this.hide()} : ()=>{};
    const url = (parseInt(item.active_url)) ? item.url : '';
    const url_type = (parseInt(item.active_url)) ? item.url_type : '';
    const no_url = (parseInt(item.active_url)) ? '' : true;


    return <>
      <TypedLink onClick={onClick} no_url={no_url} link={{type: url_type, url: url, title: item.title}}></TypedLink>
    </>;
  }

  show_accordions(pages){

    return <>
      { Object.keys(pages).map((id,key)=>{
        const val = pages[id];
        const toggleOnClick = parseInt(val.active_url)===0 ? true : false;

        if(val['sublevels'] && Object.keys(val['sublevels']).length>0){
          return <Accordion key={val.id} togleOnHeaderClick={toggleOnClick} id={val.id} header={this.show_accordion_header(val)} content={this.show_accordions(val['sublevels'])}></Accordion>
        }else{
          return <li className='no_sub' key={val.id}><TypedLink onClick={()=>{this.hide()}} link={{type: val.url_type, url: val.url, title: val.title}}></TypedLink></li>
        }

      })}
    </>
    
  }

  
    
  render() {

      return <SlideInContent ref={this.animationObjectRef}
        className="container floating_container page_products_menu">
        <div className="header_back"><ReactSVG className='products_back_icon' src="assets/images/back.svg" onClick={() => this.hide()} /></div>
          <div className='header_menu_items_cont'>
            <ul className='accordions_cont'>
            {this.show_accordions(window.AppRef.current.state.menus[1])}
            </ul>
            <div className='drk_brave'><img alt="" src="assets/images/drk_hun_logo.png"/></div>
          </div>
      </SlideInContent>
  }

    

}


export default ProductsMenu;